import getStore from 'services/getStore';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import { getBlock, getInteractionsFromTopicAndState } from 'selectors/block';
import { Block } from '@chameleoncreator/creator-app';

let cachedInteractions = {};

export default (topic: Block | null = null) => {
  const state = getStore().getState();
  const block = getBlock(
    state.blocks,
    topic ? topic.id : getCurrentTopic()!.id
  );

  if (
    window.dev &&
    !window?.dev() &&
    topic?.id &&
    !cachedInteractions[topic.id]
  ) {
    cachedInteractions[topic.id] = getInteractionsFromTopicAndState(
      state,
      block
    );

    return cachedInteractions[topic.id];
  }

  return getInteractionsFromTopicAndState(state, block);
};
